import BigNumber from 'bignumber.js'
import { useEffect, useState } from 'react'
import { useWeb3Context } from './useWeb3Context';
import { universeContract } from '../utils/contracts';

function useTotalSupply(refresh: boolean = false) {
    const { provider } = useWeb3Context();
    const [totalSupply, setTotalSupply] = useState(new BigNumber(0).toString())
    const [mintedCount, setMintedCount] = useState(new BigNumber(0).toString())
    const [isSupplyLoading, setIsSupplyLoading] = useState(true)
    const [isSoldOut, setIsSoldOut] = useState(false)

    useEffect(() => {
        const getTotalSupply = async () => {
            const supply = await universeContract(provider).totalSupply();
            setTotalSupply(supply)
            const mCount = await universeContract(provider).collectionSupply();
            setMintedCount(mCount)
            if (supply && mCount) {
                setIsSupplyLoading(false);
            }
            if (new BigNumber(supply.toString()).isEqualTo(mCount.toString())) {
                setIsSoldOut(true);
            }
        }

        getTotalSupply();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh])

    useEffect(() => {
        return () => {
            setTotalSupply(new BigNumber(0).toString())
            setMintedCount(new BigNumber(0).toString())
        };
    }, []);

    return {
        totalSupply,
        mintedCount,
        isSoldOut,
        isSupplyLoading
    };
}

export default useTotalSupply;